import { render, staticRenderFns } from "./CategoryPicker.vue?vue&type=template&id=c4ef5398"
import script from "./CategoryPicker.vue?vue&type=script&lang=js"
export * from "./CategoryPicker.vue?vue&type=script&lang=js"
import style0 from "./CategoryPicker.vue?vue&type=style&index=0&id=c4ef5398&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports